module.exports = __webpack_public_path__ + "static/media/space-breathe.c8403d68.jpg";